var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"nv",rawName:"v-nv:scope",value:('room-images'),expression:"'room-images'",arg:"scope"}],staticClass:"room-images"},[_c('div',{directives:[{name:"nv",rawName:"v-nv"}],staticClass:"room-image",style:(_vm.backgroundStyle),on:{"nv-back":_vm.goBack}})])
}
var staticRenderFns = []

export { render, staticRenderFns }